import React from "react";
import Header from "../components/Header";

const Checkout = () => {
  return (
    <div>
      <Header />
    </div>
  );
};

export default Checkout;
